import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  TextField,
  Grid,
  Button,
  Paper,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import TabPanel from "../../../component/TabPanel";
import { handleAxiosError } from "../../../config/action-config";
import { showAlert } from "../../../actions/alert";
import { getIndustryList, getStageList, updateSales } from "../../../api/sales";
import { Controller, useForm } from "react-hook-form";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import dayjs from "dayjs";
import ViewSalesFollowup from "./view.sales.followup";
import ViewSalesContacts from "./view.sales.contacts";
import ViewSalesNotes from "./view.sales.notes";

export default function ViewSales({ preloadedValues, refresh }) {
  const user = useSelector((state) => state.user);
  const params = useParams();
  const dispatch = useDispatch();
  const [tabIndex, setTabIndex] = useState(0);
  const [stageListData, setStageListData] = useState([]);
  const [IndustryListData, setIndustryListData] = useState([]);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({ defaultValues: preloadedValues });

  useEffect(() => {
    industryList();
    stageList();
  }, []);

  async function onSalesUpdate(newdata) {
    try {
      const { data } = await updateSales(params.id, newdata, user.token);
      refresh();
      // loadMasterData();
      dispatch(showAlert(data.msg));
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  async function industryList() {
    try {
      const { data } = await getIndustryList(user.token);
      setIndustryListData(data.records);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  async function stageList() {
    try {
      const { data } = await getStageList(user.token);
      setStageListData(data.records);
    } catch (error) {
      handleAxiosError(error, dispatch);
    }
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
      <Paper sx={{ p: "1rem" }}>
        <Box
          sx={{
            display: "flex",
            pb: 1,
            mb: 1,
            borderBottom: 1,
            justifyContent: "space-between",
          }}
        ></Box>
        <Grid container spacing={2} sx={{ pt: "1rem" }}>
          <Grid item xs={12} md={6} lg={4}>
            <FormControl fullWidth required error={Boolean(errors.industry_value)}>
              <InputLabel id="demo-simple-select-label-a">Industry</InputLabel>
              <Controller
                render={(props) => (
                  <Select value={props.value} onChange={props.onChange}>
                    {IndustryListData.map((c, i) => (
                      <MenuItem key={i} value={c.industry_value}>
                        {c.industry_display_value}
                      </MenuItem>
                    ))}
                  </Select>
                )}
                name="industry_value"
                control={control}
                rules={{
                  required: "Please select Industry value",
                }}
              />
              <FormHelperText>{errors.industry_value?.message}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <FormControl fullWidth required error={Boolean(errors.stage_value)}>
              <InputLabel id="demo-simple-select-label-a">Stage</InputLabel>
              <Controller
                render={(props) => (
                  <Select value={props.value} onChange={props.onChange}>
                    {stageListData.map((s, i) => (
                      <MenuItem key={i} value={s.stage_value}>
                        {s.stage_display}
                      </MenuItem>
                    ))}
                  </Select>
                )}
                name="stage_value"
                control={control}
                rules={{
                  required: "Please select Stage value",
                }}
              />
              <FormHelperText>{errors.stage_value?.message}</FormHelperText>
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <FormControl fullWidth required error={Boolean(errors.priority)}>
              <InputLabel id="demo-simple-select-label-a">Priority</InputLabel>
              <Controller
                render={(props) => (
                  <Select value={props.value} onChange={props.onChange}>
                    <MenuItem value="1">1</MenuItem>
                    <MenuItem value="2">2</MenuItem>
                    <MenuItem value="3">3</MenuItem>
                    <MenuItem value="4">4</MenuItem>
                    <MenuItem value="5">5</MenuItem>
                  </Select>
                )}
                name="priority"
                control={control}
                rules={{
                  required: "Please select priority value",
                }}
              />
              <FormHelperText>{errors.priority?.message}</FormHelperText>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              name="company_name"
              fullWidth
              label="Company"
              type="text"
              variant="outlined"
              inputRef={register({
                required: "Company is required.",
              })}
              required
              error={Boolean(errors.company_name)}
              helperText={errors.company_name?.message}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <TextField
              name="email"
              fullWidth
              label="Email"
              type="text"
              variant="outlined"
              inputRef={register({
                required: "Email is required.",
              })}
              required
              error={Boolean(errors.email)}
              helperText={errors.email?.message}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              name="linkedin_url"
              fullWidth
              label="LinkedIn URL"
              type="text"
              variant="outlined"
              inputRef={register({
                required: "LinkedIn URL is required.",
                pattern: {
                  value:
                    /^(http(s)?:\/\/)?([\w]+\.)?linkedin\.com\/(pub|in|profile)/,
                  message: "Please enter a valid linkedin url.",
                },
              })}
              required
              error={Boolean(errors.linkedin_url)}
              helperText={errors.linkedin_url?.message}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              name="project_name"
              fullWidth
              label="Project Name"
              type="text"
              variant="outlined"
              inputRef={register({
                required: "Project name is required.",
              })}
              required
              error={Boolean(errors.project_name)}
              helperText={errors.project_name?.message}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              name="contact"
              fullWidth
              label="Contact"
              type="text"
              variant="outlined"
              inputRef={register({
                required: "Contact Number is required.",
              })}
              required
              error={Boolean(errors.contact)}
              helperText={errors.contact?.message}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              name="probability"
              fullWidth
              label="Probability"
              type="text"
              variant="outlined"
              inputRef={register({
                required: "Probability is required.",
              })}
              required
              error={Boolean(errors.probability)}
              helperText={errors.probability?.message}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              name="address"
              fullWidth
              label="Address"
              type="text"
              variant="outlined"
              inputRef={register({
                required: "Address is required.",
              })}
              required
              error={Boolean(errors.address)}
              helperText={errors.address?.message}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              name="project_description"
              fullWidth
              label="Project description"
              type="text"
              variant="outlined"
              inputRef={register({
                required: "Project description is required.",
              })}
              required
              error={Boolean(errors.project_description)}
              helperText={errors.project_description?.message}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              name="estimated_budget"
              fullWidth
              label="Estimated Budget($)"
              type="text"
              variant="outlined"
              inputRef={register({
                required: "Estimated budget is required.",
              })}
              required
              error={Boolean(errors.estimated_budget)}
              helperText={errors.estimated_budget?.message}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              name="key_stakeholder"
              fullWidth
              label="Key Stakeholder"
              type="text"
              variant="outlined"
              inputRef={register({
                required: "key stakeholder  is required.",
              })}
              required
              error={Boolean(errors.key_stakeholder)}
              helperText={errors.key_stakeholder?.message}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <FormControl
              required
              fullWidth
              error={Boolean(errors.estimated_close_date)}
            >
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <Controller
                  render={(props) => (
                    <DesktopDatePicker
                      value={props.value || ""}
                      shouldDisableDate={disablePrevDates(
                        dayjs(new Date()).subtract(1, "days").toJSON()
                      )}
                      label="Estimated Close Date"
                      onChange={props.onChange}
                      renderInput={(params) => (
                        <TextField
                        required
                          error={Boolean(errors.estimated_close_date)}
                          {...params}
                        />
                      )}
                    />
                  )}
                  rules={{
                    required: "Estimated Close Date  is required.",
                  }}
                  name="estimated_close_date"
                  control={control}
                />
              </LocalizationProvider>
              <FormHelperText>
                {errors.estimated_close_date?.message}
              </FormHelperText>
            </FormControl>
          </Grid>
          {user.role === "Partner" ? (
            <Grid item xs={12} md={6} lg={4}>
              {
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "right",
                    columnGap: 1,
                    ml: "auto",
                  }}
                >
                  <Button
                    variant="contained"
                    onClick={handleSubmit(onSalesUpdate)}
                    type="submit"
                    style={{ padding: "5px 7px" }}
                    className="blue-button"
                  >
                    Update
                  </Button>
                </Box>
              }
            </Grid>
          ) : (
            <></>
          )}
        </Grid>
      </Paper>
      <br />

      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tabIndex}
          onChange={(e, nv) => {
            setTabIndex(nv);
          }}
          aria-label="basic tabs example"
        >
          <Tab
            label="Follow Up"
            id="simple-tab-0"
            aria-controls="simple-tabpanel-0"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
          <Tab
            label="Contacts"
            id="simple-tab-1"
            aria-controls="simple-tabpanel-1"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
          <Tab
            label="notes"
            id="simple-tab-2"
            aria-controls="simple-tabpanel-2"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
        </Tabs>
      </Box>
      <TabPanel value={tabIndex} index={0}>
        <Paper>
          <ViewSalesFollowup
            leadId={preloadedValues.lead_id}
          ></ViewSalesFollowup>
        </Paper>
      </TabPanel>
      <TabPanel value={tabIndex} index={1}>
        <Paper>
          <ViewSalesContacts
            leadId={preloadedValues.lead_id}
          ></ViewSalesContacts>
        </Paper>
      </TabPanel>
      <TabPanel value={tabIndex} index={2}>
        <Paper>
          <ViewSalesNotes leadId={preloadedValues.lead_id}></ViewSalesNotes>
        </Paper>
      </TabPanel>
    </Box>
  );
}

function disablePrevDates(startDate) {
  const startSeconds = Date.parse(startDate);
  return (date) => {
    return Date.parse(date) < startSeconds;
  };
}
